// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"74a5b09a","123":"10e8032c","152":"7e162b3c","192":"0dea5354","250":"4e1125f1","282":"fe83920d","423":"0674e0b1","474":"28af82ea","725":"0a163c27","736":"35a9cd57","787":"bd02818e","846":"03a36ab5","853":"118e7fb0","882":"e2377946"}[chunkId] + ".chunk.js";
};